import './header-menu.scss';

import { ConfigProvider, Menu } from 'antd';
import { useTranslation } from 'react-i18next';

import { LocalizedNavLink } from '@/shared/ui';

import type { INavItem } from '../../hooks/useNavItems';

/**
 * Строка меню — во всю шапку (72px без нижней границы), чтобы подчёркивание ложилось
 * на её край; поля пунктов 10px, как у разделов в шапке лизингового кабинета.
 */
const MENU_THEME = {
  components: {
    Menu: {
      horizontalLineHeight: '71px',
      itemPaddingInline: 10,
      itemBg: 'transparent'
    }
  }
};

interface IProps {
  items: INavItem[];
  activeCode?: string;
}

/**
 * Разделы в шапке на широком экране: подписи без иконок, активный подчёркнут.
 * Не помещающиеся пункты antd убирает в «…».
 */
const HeaderMenu: React.FC<IProps> = ({ items, activeCode }) => {
  const { t } = useTranslation();

  return (
    <nav className="header-menu" aria-label={t('layout.nav.label')}>
      <ConfigProvider theme={MENU_THEME}>
        <Menu
          mode="horizontal"
          className="header-menu__list"
          selectedKeys={activeCode ? [activeCode] : []}
          items={items.map(({ code, label, route }) => ({
            key: code,
            label: <LocalizedNavLink to={route}>{label}</LocalizedNavLink>
          }))}
        />
      </ConfigProvider>
    </nav>
  );
};

export default HeaderMenu;
